import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { Button, Dialog, Grid } from "@mui/material";
import Signifier from "../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import { selectClientValue } from "../../App/State/Slices/SelectedClientSlice";
import UserTableCell from "./Components/UserTableCell";
import SortableTable from "../../App/Components/Table/SortableTable";
import { getUsers } from "../../App/Services/UserService";
import CreateModal from "./Components/CreateModal";
import { selectUserPermissionsValue } from "../../App/State/Slices/UserPermissionsSlice";
import { Roles } from "../../App/Enums/Roles";

function UsersPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "80%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const selectClient = useSelector(selectClientValue);
  const roles = useSelector(selectUserPermissionsValue);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [canEditCareersRoles, setCanEditCareersRoles] = useState(true);
  // will be true if the logged in user has the CRM User Management role
  const [canEditCrmRoles, setCanEditCrmRoles] = useState(true);

  const columns = [
    { label: "Name", propName: "user.firstName" },
    { label: "Email Address", propName: "user.emailAddress" },
    { label: "Date Created", propName: "user.dateCreated" },
    { label: "User Role(s)", propName: "" },
    { label: "", propName: "" },
  ];

  useEffect(() => {
    for (var i in roles) {
      if (roles[i]?.BaseClientID === selectCareersClient?.centralClientId) {
        if (roles[i]?.CRMRole === 2) {
          setCanEditCrmRoles(true);
        } else {
          setCanEditCrmRoles(false);
        }
      }
    }
  }, [selectCareersClient, roles, canEditCrmRoles]);

  useEffect(() => {
    //add role state here
    if (selectCareersClient != null) {
      setLoading(true);

      var isSA = false;
      var isAdmin = false;
      var isLightAdmin = false;
      var isClientAdmin = false;

      for (var i in roles) {
        if (roles[i]?.BaseClientID === selectCareersClient?.centralClientId) {
          //If user DOES NOT have a careers role
          if (roles[i].CareersRoleID == null) {
            setCanEditCareersRoles(false);
            break;
          } else {
            setCanEditCareersRoles(true);
          }

          if (Roles.SuperAdmin === roles[i]?.CareersRoleID.toUpperCase()) {
            isSA = true;
          }
          if (Roles.Admin === roles[i]?.CareersRoleID.toUpperCase()) {
            isAdmin = true;
          }
          if (Roles.LightAdmin === roles[i]?.CareersRoleID.toUpperCase()) {
            isLightAdmin = true;
          }
          if (Roles.ClientAdmin === roles[i]?.CareersRoleID.toUpperCase()) {
            isClientAdmin = true;
          }
          break;
        }
      }

      getUsers(isSA, isAdmin, isLightAdmin, isClientAdmin).then((response) => {
        setTableData(response);
        setLoading(false);
      });
    } else if (selectCareersClient == null && selectClient.hasCrm) {
      // If the Base client DOES NOT have careers, but does have CRM
      // load table data with CRM Users
      getUsers(false, false, false, false).then((response) => {
        setTableData(response);
        setLoading(false);
      });
    }
  }, [selectCareersClient, roles, selectClient.hasCrm]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">{selectClient.clientName} Users Page</h1>
        <div className={classes.root}>
          {selectCareersClient == null && !selectClient.hasCrm ? (
            <div className={classes.hint}>
              <span>Select a client</span>
            </div>
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <Button
                  style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    marginRight: "20px",
                  }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={() => setCreateModal(true)}
                >
                  Add User
                </Button>
              </Grid>
              <SortableTable
                columns={columns}
                tableData={tableData}
                setTableData={setTableData}
                rowComponent={UserTableCell}
                loading={loading}
                customProps={{
                  selectClient: selectClient,
                  canEditCareersRoles: canEditCareersRoles,
                  canEditCrmRoles: canEditCrmRoles,
                }}
              />
            </Grid>
          )}
        </div>
      </div>
      <Dialog
        open={createModal}
        fullWidth
        maxWidth="sm"
        onClose={() => setCreateModal(false)}
      >
        <CreateModal
          setModal={setCreateModal}
          setTableData={setTableData}
          setShowSignifier={setShowSignifier}
          setResponseMessage={setResponseMessage}
          setShowError={setShowError}
          canEditCareersRoles={canEditCareersRoles}
          canEditCrmRoles={canEditCrmRoles}
        />
      </Dialog>
    </>
  );
}

export default UsersPage;
